import {IMaskInput} from "react-imask";

const MobilePhoneInput = ({phoneValue, setPhoneValue, className, onKeyDown}) => {
    return <IMaskInput
        className={className}
        value={phoneValue}
        mask={'{+375} (C`C) `D`D`D-`D`D-`D`D'}
        blocks={{
            C: {
                mask: '0',
                placeholderChar: 'y'
            },
            D: {
                mask: '0',
                placeholderChar: 'x'
            }
        }}
        overwrite={false}
        lazy={false}
        unmask={true}
        onAccept={
            (value, mask) => setPhoneValue(value)
        }
        onKeyDown={onKeyDown}
    />
}

export default MobilePhoneInput